<template>
  <div class="indent-controls">
    <button @click="handleOutdent" :disabled="!canOutdent"
      class="border rounded px-2 flex items-center h-8 cursor-pointer hover:bg-gray-100 bg-white"
      title="Decrease Indent">
      <Icon name="lucide:indent-decrease" />
    </button>
    <button @click="handleIndent" :disabled="!canIndent"
      class="border rounded px-2 flex items-center h-8 cursor-pointer hover:bg-gray-100 bg-white"
      title="Increase Indent">
      <Icon name="lucide:indent-increase" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed, defineModel } from 'vue'

const editor = defineModel('editor')

const handleIndent = () => {
  if (editor.value?.commands?.indent) {
    editor.value.commands.indent()
  } else {
    console.error('Indent command is not available on the editor')
  }
}

const handleOutdent = () => {
  if (editor.value?.commands?.outdent) {
    editor.value.commands.outdent()
  } else {
    console.error('Outdent command is not available on the editor')
  }
}

const canIndent = computed(() => {
  if (!editor.value) return false
  const { $from, $to } = editor.value.state.selection
  let can = false

  editor.value.state.doc.nodesBetween($from.pos, $to.pos, (node) => {
    if (['paragraph', 'heading', 'listItem'].includes(node.type.name)) {
      const indent = node.attrs.indent || 0
      if (indent < 7) {
        can = true
      }
    }
  })

  return can
})

const canOutdent = computed(() => {
  if (!editor.value) return false
  const { $from, $to } = editor.value.state.selection
  let can = false

  editor.value.state.doc.nodesBetween($from.pos, $to.pos, (node) => {
    if (['paragraph', 'heading', 'listItem'].includes(node.type.name)) {
      const indent = node.attrs.indent || 0
      if (indent > 0) {
        can = true
      }
    }
  })

  return can
})
</script>

<style scoped>
.indent-controls {
  display: flex;
  gap: 4px;
}
</style>